import { isOtherLookup } from '../pages/wizard/criminal/criminalConstants';

export function isOtherDeliveryMethodId(id: string, methods: { id: string; name: string; code?: string }[]): boolean {
  const item = methods.find((m) => m.id === id);
  return item ? isOtherLookup(item.name, item.code ?? item.id) : id.toLowerCase() === 'other';
}

export function draftHasOtherDeliverySelected(draft: {
  deliveryMethodIds: string[];
  deliveryMethods: string[];
}): boolean {
  return (
    draft.deliveryMethods.some((name) => isOtherLookup(name)) ||
    draft.deliveryMethodIds.some((id) => isOtherLookup('', id))
  );
}

/** True when "Other" is selected (detail text is required). */
export function draftRequiresOtherDeliveryText(draft: {
  deliveryMethodIds: string[];
  deliveryMethods: string[];
}): boolean {
  return draftHasOtherDeliverySelected(draft);
}

/** True when "Other" is the sole selected delivery method (API sends other_method as null when text empty). */
export function draftOtherDeliveryExclusive(draft: {
  deliveryMethodIds: string[];
  deliveryMethods: string[];
}): boolean {
  return draftHasOtherDeliverySelected(draft) && draft.deliveryMethodIds.length === 1;
}
